<div
    class="nav-bar-tabs bg-dark light d-flex flex-row row w-100 p-0 m-0 position-fixed bottom-0 h-10"
    [ngStyle]="{ opacity: isLogged ? 1 : 0 }"
>
    <div
        *ngFor="let item of navItems; let i = index"
        class="col-3 h-100 d-flex flex-column p-0 m-0 position-relative"
        [class.opacity-50]="isNavItemDisabled(i)"
        (click)="
            !isNavItemDisabled(i) &&
                (item?.modalName ? openModal(item) : goPage(item))
        "
        [style.pointer-events]="isNavItemDisabled(i) ? 'none' : 'auto'"
    >
        <div *ngIf="!isActive(item.url); else itemSelected" class="h-100">
            <div
                class="center d-flex flex-column _nav_icon h-55 position-relative nav-item-icon"
            >
                <div class="position-relative d-inline-block">
                    <img
                        src="/assets/svg/nav/{{ item.img }}-white.svg"
                        height="20px"
                    />
                    <span
                        *ngIf="isNavItemDisabled(i)"
                        class="position-absolute"
                        style="font-size: 8px; top: -8px; right: -8px"
                        >🔒</span
                    >
                </div>
            </div>

            <div class="w-100 center h-45 nav-link">
                {{ 'nav.' + item.name | translate }}
            </div>
        </div>

        <ng-template #itemSelected>
            <div
                class="center d-flex flex-column _nav_icon h-55 position-relative nav-item-icon"
            >
                <div class="position-relative d-inline-block">
                    <img
                        src="/assets/svg/nav/{{ item.img }}-select.svg"
                        height="20px"
                    />
                    <span
                        *ngIf="isNavItemDisabled(i)"
                        class="position-absolute"
                        style="font-size: 8px; top: -8px; right: -8px"
                        >🔒</span
                    >
                </div>
            </div>

            <div class="w-100 center h-45 activ-nav">
                {{ 'nav.' + item.name | translate }}
            </div>
        </ng-template>
    </div>
</div>
